export default __webpack_public_path__ + "static/media/icons8-menu.b47596d5.svg";